import { render, staticRenderFns } from "./NoAccounts.vue?vue&type=template&id=27d1de39&"
import script from "./NoAccounts.vue?vue&type=script&lang=ts&"
export * from "./NoAccounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports